export interface IAgent {
    rating: number;
    image: string;
    name: string;
    address: string;
    profileType: string;
    facebookLink?: string;
    twitterLink?: string;
    instagramLink?: string;
    linkedInLink?: string;
}
export class Agent implements IAgent {
    constructor(
        public name: string,
        public address: string,
        public rating: number,
        public profileType: string,
        public image: string,
        public facebookLink?: string,
        public twitterLink?: string,
        public instagramLink?: string,
        public linkedInLink?: string,
    ) { }
}
